import { FilesAttachDialog } from "./FilesAttachDialog";
import { ManagedContentAttachDialog } from "./ManagedContentAttachDialog";
import type { AttachFileDialogProps } from "./types";

export const AttachFileDialog = (props: AttachFileDialogProps) => {
  if (props.variant === "managed-content-records") {
    return <ManagedContentAttachDialog {...props} />;
  }

  return <FilesAttachDialog {...props} />;
};
